<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import { BFormSelect } from 'bootstrap-vue-next';
import {
  AVAILABLE_LAYOUTS,
  DEFAULT_APP_LAYOUT,
  type AppLayoutCode,
} from '@integro/core';
import { pgettext } from '@integro/gettext';

const instance = getCurrentInstance();
const proxy = instance?.proxy as any;
const root = proxy?.$root;
const $app = computed(() => root?.$app);

function labelFor(code: AppLayoutCode, fallback: string): string {
  switch (code) {
    case 'tabbed':
      return pgettext('LayoutMode', 'Tabbed layout');
    case 'sidebar':
      return pgettext('LayoutMode', 'Sidebar layout');
    default:
      return fallback;
  }
}

const options = computed(() =>
  AVAILABLE_LAYOUTS.map((l) => ({
    value: l.code,
    text: labelFor(l.code, l.label),
  })),
);

const layoutCode = computed<AppLayoutCode>({
  get: () => ($app.value?.layout as AppLayoutCode) ?? DEFAULT_APP_LAYOUT,
  set: (value: AppLayoutCode) => {
    const app = $app.value;
    if (!app || app.layout === value) {
      return;
    }
    app.setLayout(value);
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  },
});
</script>

<template>
  <BFormSelect
    v-model="layoutCode"
    :options="options"
    size="sm"
    @click.stop
    @mousedown.stop
  />
</template>

<style scoped></style>
